import { ISOState } from '../state/so.state';
import { createSelector } from '@ngrx/store';
import { IAppState } from '../state/app.state';


const select_so = (state: IAppState) => state.so;

export const getAllSODetails = createSelector(
    select_so, (state: ISOState) => state.getAllSODetails
);

export const getSOSuccessMsg = createSelector(
    select_so, (state: ISOState) => state.getSOSuccessMessage
);

export const getSOErrorMsg = createSelector(
    select_so, (state: ISOState) => state.getSOErrorMessage?.error || state.getSOErrorMessage
);

export const getSOCodeSuccess = createSelector(
    select_so, (state: ISOState) => state.getSOCodeSuccess
);

export const getSOByIdSuccess = createSelector(
    select_so, (state: ISOState) => state.getSOByIdSuccess
);

export const getSOByIdError = createSelector(
    select_so, (state: ISOState) => state.getSOByIdError?.error || state.getSOByIdError
);
export const getInactiveSOSuccess = createSelector(
    select_so, (state: ISOState) => state.getInactiveSOSuccess
);

export const getInActiveSOError = createSelector(
    select_so, (state: ISOState) => state.getInactiveSOError?.error || state.getInactiveSOError
);
export const getCloseSOSuccess = createSelector(
    select_so, (state: ISOState) => state.getCloseSOSuccess
);

export const getCloseSOError = createSelector(
    select_so, (state: ISOState) => state.getCloseSOError?.error || state.getCloseSOError
);
export const getForcastSalesSuccess = createSelector(
    select_so, (state: ISOState) => state.getForcastSalesSuccess
);
export const getForcastSalesError = createSelector(
    select_so, (state: ISOState) => state.getForcastSalesError?.error ||state.getForcastSalesError
);
export const getaddForcastSalesSuccess = createSelector(
    select_so, (state: ISOState) => state.getaddForcastSalesSuccess
);
export const getaddForcastSalesError = createSelector(
    select_so, (state: ISOState) => state.getaddForcastSalesError?.error || state.getaddForcastSalesError
);
export const geteditForcastSalesSuccess = createSelector(
    select_so, (state: ISOState) => state.geteditForcastSalesSuccess
);
export const geteditForcastSalesError = createSelector(
    select_so, (state: ISOState) => state.geteditForcastSalesError?.error || state.geteditForcastSalesError
);
//dispatch orders
export const getDONumberSuccess = createSelector(
    select_so, (state: ISOState) => state.getDONumberSuccess
);
export const getDONumberError = createSelector(
    select_so, (state: ISOState) => state.getDONumberError?.error || state.getDONumberError
);
export const getAddDOSuccess = createSelector(
    select_so, (state: ISOState) => state.addDOSuccess
);
export const getAddDOError = createSelector(
    select_so, (state: ISOState) => state.addDOError?.error || state.addDOError
);
export const getAllDOsSuccess = createSelector(
    select_so, (state: ISOState) => state.getAllDOSuccess
);
export const getAllDOsError = createSelector(
    select_so, (state: ISOState) => state.getAllDOError?.error || state.getAllDOError
);
export const getDOsByPSSuccess = createSelector(
    select_so, (state: ISOState) => state.getDOsByPSSuccess
);
export const getDOsByPSError = createSelector(
    select_so, (state: ISOState) => state.getDOsByPSError?.error || state.getDOsByPSError
);
export const getDOdetailsSuccess = createSelector(
    select_so, (state: ISOState) => state.getDOdetailsSuccess
);
export const getDOdetailsError = createSelector(
    select_so, (state: ISOState) => state.getDOdetailsError?.error || state.getDOdetailsError
);
export const getAddPackslipsSuccess = createSelector(
    select_so, (state: ISOState) => state.getAddPackslipsSuccess
);
export const getAddPackSlipsError = createSelector(
    select_so, (state: ISOState) => state.getAddPackSlipsError?.error || state.getAddPackSlipsError
);
export const getAllPackSlipsSuccess = createSelector(
    select_so, (state: ISOState) => state.getAllPackSlipsSuccess
);
export const getAllPackSlipsError = createSelector(
    select_so, (state: ISOState) => state.getAllPackSlipsError?.error || state.getAllPackSlipsError
);
export const getEditPackSlipsSuccess = createSelector(
    select_so, (state: ISOState) => state.getEditPackSlipsSuccess
);
export const getEditPackSlipsError = createSelector(
    select_so, (state: ISOState) => state.getEditPackSlipsError?.error || state.getEditPackSlipsError
);
export const getRpsBasedOnMonthSuccess = createSelector(
    select_so, (state: ISOState) => state.getRpsBasedOnMonthSuccess
);
export const getRpsBasedOnMonthError = createSelector(
    select_so, (state: ISOState) => state.getRpsBasedOnMonthError?.error || state.getRpsBasedOnMonthError
);
export const getDosByFormulaIdSuccess = createSelector(
    select_so, (state: ISOState) => state.getDosByFormulaIdSuccess
);

export const getDosByFormulaIdError = createSelector(
    select_so, (state: ISOState) => state.getDosByFormulaIdError?.error || state.getDosByFormulaIdError
);
export const inActivatePsSuccess = createSelector(
    select_so, (state: ISOState) => state.inActivatePsSuccess
);

export const inActivatePsError = createSelector(
    select_so, (state: ISOState) => state.inActivatePsError?.error || state.inActivatePsError
);
export const getSOsByCustomerIdSuccess = createSelector(
    select_so, (state: ISOState) => state.getSOsByCustomerIdSuccess
);
export const getSOsByCustomerIdError = createSelector(
    select_so, (state: ISOState) => state.getSOsByCustomerIdError?.error || state.getSOsByCustomerIdError
);
export const cancelDoSucces = createSelector(
    select_so, (state: ISOState) => state.cancelDoSucces
);
export const cancelDoError = createSelector(
    select_so, (state: ISOState) => state.cancelDoError?.error || state.cancelDoError
);
